import Rev34 from "./Rev34";

// Registry of all public product release pages.
// Add new releases here as they ship, e.g. rev35: Rev35.
const releases = {
	rev34: Rev34
};

export default releases;
